import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./schedule.css";

import LoaderModal from "../LoaderModal";

import useSWR, { mutate } from "swr";
import { domain } from "../../../../../global/domain";
import { fetcher } from "../../../../../services/fetcher";

import { addSession } from "../../../../../services/followSession";
import { getTimesWithDuration } from "../../../../../services/times";
import { useParams } from "react-router-dom";

import Select from "react-select";
import { iconsColor } from "./../../../../../global/iconsColor";

const Schedule = ({ closing, mutate, userId }) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState(1);

  const [formState, setFormState] = useState({
    duration: null,
    date: null,
    time: null,
    title: null,
    meetLink: null,
  });

  const [times, setTimes] = useState([]);

  var arabicDays = [
    "اﻷحد",
    "اﻷثنين",
    "الثلاثاء",
    "اﻷربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ];

  var ArabicMonths = [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوث",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];

  const formatedDate = (date) => {
    if (!date) {
      return;
    }
    const offset = date.getTimezoneOffset();
    const yourDate = new Date(date.getTime() - offset * 60 * 1000);
    return yourDate.toISOString().split("T")[0];
  };

  return (
    <div className="w-full x-sm:text-xs md:text-base xl:text-lg 2xl:text-3xl">
      {stage === 1 && (
        <div className="w-full flex flex-col space-y-4 text-reghda-black x-sm:mt-12 sm:mt-16 md:mt-20 2xl:mt-36">
          <fieldset className="w-full">
            <Select
              styles={{
                option: (provided, state) => ({
                  ...provided,
                  color: state.isFocused ? "white" : "bg-reghda-black",
                  backgroundColor: state.isFocused ? iconsColor : "white",
                }),
                control: (base, state) => ({
                  ...base,
                  "&:hover": { borderColor: iconsColor }, // border style on hover
                  border: "1px solid lightgray", // default border color
                  boxShadow: "none", // no box-shadow
                }),
              }}
              classNamePrefix="place-holder-center text-center outline-none focus:outline-none"
              className="place-holder-center text-center outline-none focus:outline-none"
              placeholder={"اختر مدة"}
              onChange={(selectedOption) => {
                setFormState({
                  ...formState,
                  duration: selectedOption.value,
                });
              }}
              options={[
                { label: "نصف ساعة", value: 30 },
                { label: "ساعة", value: 60 },
                { label: "ساعة و نصف", value: 90 },
                { label: "ساعتان", value: 120 },
                { label: "ساعتان و نصف", value: 150 },
                { label: "ثلاث ساعات", value: 180 },
              ]}
            />
          </fieldset>
          <button
            onClick={() => {
              if (formState.duration) {
                setStage(stage + 1);
              }
            }}
            className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
          >
            التالي
          </button>
          {stage !== 1 && (
            <button
              onClick={() => setStage(stage - 1)}
              className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
            >
              العودة
            </button>
          )}
        </div>
      )}

      {stage === 2 && (
        <div className="x-sm:w-full flex flex-col items-center self-center text-reghda-black">
          <div className="x-sm:w-full">
            <Calendar
              minDate={new Date()}
              calendarType="Arabic"
              locale="ar-DZ"
              onChange={(value) => {
                setFormState({
                  ...formState,
                  date: value,
                });
              }}
              value={formState.date}
            />
          </div>
          <div className="w-full flex flex-col space-y-4">
            <button
              onClick={async () => {
                if (formState.date && formState.duration) {
                  setLoading(true);
                  const res = await getTimesWithDuration(
                    formatedDate(formState.date),
                    formState.duration
                  );
                  setTimes([...res.data.available_times]);
                  setLoading(false);
                  setStage(stage + 1);
                }
              }}
              className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
            >
              التالي
            </button>
            {stage !== 1 && (
              <button
                onClick={() => setStage(stage - 1)}
                className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
              >
                العودة
              </button>
            )}
          </div>
        </div>
      )}

      {stage === 3 && times.length > 0 && (
        <div className="w-full ">
          <div className="w-full flex flex-col space-y-4 text-reghda-black x-sm:mt-12 sm:mt-16 md:mt-20 2xl:mt-36">
            <fieldset className="w-full">
              <Select
                styles={{
                  option: (provided, state) => ({
                    ...provided,
                    color: state.isFocused ? "white" : "bg-reghda-black",
                    backgroundColor: state.isFocused ? iconsColor : "white",
                  }),
                  control: (base, state) => ({
                    ...base,
                    "&:hover": { borderColor: iconsColor }, // border style on hover
                    border: "1px solid lightgray", // default border color
                    boxShadow: "none", // no box-shadow
                  }),
                }}
                classNamePrefix="place-holder-center text-center outline-none focus:outline-none"
                className="place-holder-center text-center outline-none focus:outline-none"
                placeholder={"اختر وقت"}
                onChange={(selectedOption) => {
                  setFormState({ ...formState, time: selectedOption.value });
                }}
                options={times.map((time) => {
                  return { label: time, value: time };
                })}
              />
            </fieldset>
            <button
              onClick={async () => {
                if (formState.time) {
                  setStage(stage + 1);
                }
              }}
              className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
            >
              التالي
            </button>
            {stage !== 1 && (
              <button
                onClick={() => setStage(stage - 1)}
                className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
              >
                العودة
              </button>
            )}
          </div>
        </div>
      )}

      {stage === 3 && times.length < 1 && (
        <div className="w-full ">
          <div className="w-full flex flex-col space-y-4 text-reghda-black x-sm:mt-12 sm:mt-16 md:mt-20 2xl:mt-36">
            <p className="w-full text-center text-red-500 2xl:text-2xl">
              هذا اليوم تم حجزه بالكامل
            </p>
            {stage !== 1 && (
              <button
                onClick={() => setStage(stage - 1)}
                className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
              >
                العودة
              </button>
            )}
          </div>
        </div>
      )}

      {stage === 4 && (
        <div className="w-full">
          <div className="w-full flex flex-col space-y-4 text-reghda-black x-sm:mt-12 sm:mt-16 md:mt-20 2xl:mt-36">
            <div className="w-full flex flex-row items-center justify-center space-x-2">
              <span>{formState.date.toString().slice(11, 15)}</span>
              <span>{ArabicMonths[formState.date.getMonth()]}</span>
              <span>{formState.date.toString().slice(8, 10)}</span>
              <span>{arabicDays[formState.date.getDay()]}</span>
            </div>
            <div className="w-full flex flex-row items-center justify-center space-x-4">
              <span className="">دقيقة</span>

              <span>{formState.duration}</span>
              <span className="font-extrabold text-reghda-blue">مدة</span>
            </div>
            <div className="w-full flex flex-row items-center justify-center space-x-4">
              <span>{formState.time}</span>
              <span className="font-extrabold text-reghda-blue">التوقيت</span>
            </div>

            <fieldset className="w-full flex flex-row items-center justify-center">
              <input
                onChange={(event) =>
                  setFormState({ ...formState, title: event.target.value })
                }
                value={formState.title}
                placeholder="عنوان الجلسة"
                type="text"
                className="w-1/2 text-reghda-black text-right p-1 pr-6 rounded-2xl border-2 border-gray-200 outline-none focus:outline-none  focus:border-pink-300"
              />
            </fieldset>

            <fieldset className="w-full flex flex-row items-center justify-center">
              <input
                onChange={(event) =>
                  setFormState({ ...formState, meetLink: event.target.value })
                }
                value={formState.meetLink}
                placeholder="رابط الملتقى"
                type="text"
                className="w-1/2 text-reghda-black text-right p-1 pr-6 rounded-2xl border-2 border-gray-200 outline-none focus:outline-none  focus:border-pink-300"
              />
            </fieldset>

            <button
              onClick={async () => {
                if (!formState.title || !formState.meetLink) {
                  return;
                }
                setLoading(true);
                const res = await addSession({
                  user: userId,
                  subscription: id,
                  title: formState.title,
                  meet_url: formState.meetLink,
                  duration: formState.duration,
                  date: formatedDate(formState.date),
                  time: formState.time,
                });
                setLoading(false);
                if (res && res.status === 200) {
                  mutate();
                  closing();
                  setFormState({
                    duration: null,
                    date: null,
                    time: null,
                    title: null,
                    meetLink: null,
                  });
                  setStage(1);
                } else {
                  alert("something wrong");
                }
              }}
              className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
            >
              تأكيد
            </button>
            {stage !== 1 && (
              <button
                onClick={() => setStage(stage - 1)}
                className="w-full bg-reghda-blue text-center text-white py-1 px-2 rounded-xl md:text-base 2xl:text-3xl outline-none focus:outline-none"
              >
                العودة
              </button>
            )}
          </div>
        </div>
      )}
      <LoaderModal modalIsOpen={loading}></LoaderModal>
    </div>
  );
};

export default Schedule;
